var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.value},on:{"change":function (ref) {
	var checked = ref.target.checked;

	return _vm.$emit('input',  _vm.as_number == true ? String(Number(checked)) : checked);
}}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.value? 'Oui': 'Non')}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cdc3006","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Forms/Elements/SubElements/Switcher.vue
// module id = 1923
// module chunks = 0